import styled from 'styled-components'
// types
import { IChildrenNode } from 'types/propTypes'

interface IProps extends IChildrenNode {
  testId?: string
  className?: string
  onClick: () => void
}

export const NavLinkCustom = ({ children, onClick, testId, className }: IProps) => {
  return (
    <Div className={className} data-testid={testId || 'link'} onClick={onClick}>
      {children}
    </Div>
  )
}

const Div = styled.div`
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`
